import React, { useEffect, useState } from 'react'
import './index.scss'
import pubsub from "@viewlift/pubsub"
import { logIn, LogInMobile, verifyEmail, VerifyMobile } from '../../Helpers'
import { updateAuthorisationStore } from '../../Helpers/authStore'
import Spinner from '../../../../components/spinner'
import { errorAlert } from '../../../../../images/icon'
import { pushStepToFlow, triggerUserMergeEvent } from '../../../helper'
import { ANALYTICS } from '../../../../helpers/analyticsMap'
import { handleStatusGaCalls } from '../../../../helpers'
import { ANALYTICSEVENTS } from '../../Helpers/analyticsMap'
import { useNavigate } from "react-router-dom";
import { parseJSON } from '../../../utils/parseJSON'
import { publishUserCreated } from '../../../Events/utils.events'
import trackEvent from "../../../../helpers/trackAnalytics"

function VerifyOtp({moduleData, screenType,data,metadataMap,consent,keyProp,isSplashLogin, isCheckoutScreen,isFreeLogin}) {
  let textColorStyle = {color: moduleData?.layout?.settings?.textColor}
  let maskedId = ''
  if(screenType.type === 'email'){
    maskedId = data.replace(/^(.)(.*)(.@.*)$/,
      (_, a, b, c) => a + b.replace(/./g, '*') + c
    );
  } else {
    maskedId = data
  }
  const [keyState, setKey] = useState(null)
  const [resendotp , setResendOtp] = useState(0)
  const [loading , setLoading] = useState(false)
  const [errMsg , setErrMsg] = useState(false)
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(30);
  const inputColor = moduleData?.layout?.settings?.inputBgColor || 'transparent'
  const inputBorderColor = moduleData?.layout?.settings?.inputBgColor || '#3a4765'
  const navigate = useNavigate()


  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
  
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);
  
    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  const getErrorMessage = (code) => {
    const sanitizeErrorMessage = (message) => {
      if (typeof message !== 'string') return 'UNKNOWN_ERROR';
      return message.replace(/[^a-zA-Z0-9_ ]/g, '').toUpperCase();
    };

    const sanitizedCode = sanitizeErrorMessage(code);
    switch(sanitizedCode) {
   case 'PHONE_INVALID':
     setErrMsg(metadataMap["PHONE_NOT_VALID"])
     break;
   case 'EMAIL_NOT_VALID':
     setErrMsg(metadataMap["EMAIL_VERIFICATION_FAILED"])
     break;
    case 'OTP_NOT_VALID':
      setErrMsg(metadataMap["OTP_MISMATCH"])
      break;
    case 'OTP_EXPIRED':
      setErrMsg(metadataMap["OTP_EXPIRED"])
      break
   default:  
   setErrMsg(metadataMap["INVALID_REQUEST_PARAMS"])
 }
 }

 let description = "We have sent a verification code. Please enter the code below to verify your email.";
  const appendText = () => {
    description = screenType.type === "email"
      ? metadataMap?.verifyEmailSubtitle.replace("'VIEWLIFT_USEREMAIL'", data)
          .replace('$terms_of_service$', createLink(metadataMap?.tosPermalink, metadataMap?.tosText))
          .replace('$privacy_policy$', createLink(metadataMap?.privacyPolicyPermalink, metadataMap?.privacyPolicyText))
      : metadataMap?.verifyMobileSubtitle.replace("'VIEWLIFT_MOBILE'", data);

    let descriptionText = document.getElementById('descriptionText');
    descriptionText.textContent = description;
  };

  const createLink = (href, text) => {
    const link = document.createElement('a');
    link.classList.add('consentLinks');
    link.target = '_blank';
    link.href = href;
    link.textContent = text;
    return link.outerHTML;
  };

  useEffect(() => {
    if(resendotp == 0) return 

    if(screenType.type === 'email'){
      logIn({email:data}).then((res) => {
        setKey(res?.identityAuthOtpInitiate?.key)
      })
      .catch((err)=>{
        console.log(err)
        getErrorMessage(err.response.data.code)
      })
      
    }else{
      LogInMobile({
        phoneNumber: data
      }).then((res) =>{
        setKey(res?.identityAuthOtpInitiate?.key)
      })
      .catch((err)=>{
        console.log(err)
        getErrorMessage(err.response.data.code)
      })
    }
  },[resendotp])

  useEffect(() => {
    if(errMsg){
      setTimeout(() => {
        setErrMsg(false)
      },10000)
    }
  },[errMsg])

  useEffect(() => {
    checkForOtp()
    appendText()
  },[])

  const checkForOtp = () => {
    if ('OTPCredential' in window) {
        const form = document.querySelector('.verifyOtp-form');
        const ac = new AbortController();
        if (form) {
          form.addEventListener('submit', e => {
            ac.abort();
          });
        }
        navigator.credentials.get({
          otp: { transport:['sms'] },
          signal: ac.signal
        }).then(otp => {

        let otpmsg = otp.code.trim()
        .split('');
        setOtp({
          otp1:otpmsg[0],
          otp2:otpmsg[1],
          otp3:otpmsg[2],
          otp4:otpmsg[3],
          otp5:otpmsg[4],
          otp6:otpmsg[5],
        })
        document.querySelector('.verifyOtpButn').classList.remove('disabled')
        }).catch(err => {
          console.log(err);
        });
  }
}
  
  const [ otp , setOtp] = useState({
    otp1:'',
    otp2:'',
    otp3:'',
    otp4:'',
    otp5:'',
    otp6:'',
  })
  function handleChange(value1, event) {
    setOtp({ ...otp , [value1]: event.target.value });
  }

  function handlePaste(value1, e){
    e.preventDefault();
      const pastedData = e.clipboardData
        .getData('text/plain')
        .trim()
        .split('');
        setOtp({
          otp1:pastedData[0],
          otp2:pastedData[1],
          otp3:pastedData[2],
          otp4:pastedData[3],
          otp5:pastedData[4],
          otp6:pastedData[5],
        })
        document.querySelector('.verifyOtpButn').classList.remove('disabled')
  }

  const resetOtpTimer=()=>{
    setOtp({
      otp1: '',
      otp2: '',
      otp3: '',
      otp4: '',
      otp5: '',
      otp6: '',
    })
    setMinutes(0);
    setSeconds(30);
  }

  const triggerCheckoutSigninStatus = (eventType, isSucces, errCode) => {
    if(isCheckoutScreen){
      const checkoutInitPageDetails = JSON.parse(sessionStorage.getItem('checkoutInitPageData'))
      let eventData = {
        "pageUrl": checkoutInitPageDetails?.pageUrl,
        "email" : screenType.type === "email" ? data : null,
        "phoneNumber" : screenType.type === "mobile" ? data : null,
        "loginVia": screenType.type === "email" ? "email" : "phone number"
      }
      !isSucces && (eventData.error = errCode)
      let analyticsData={ename: ANALYTICSEVENTS[eventType], data: eventData};
      pubsub.publish('user-analytics',analyticsData)}
  }

  const getSubmitVerificationAnalytics=async()=>{
    let obj={
      ...(screenType.type=='email' && {email:data}),
      ...(screenType.type=='mobile' && {phoneNo:data}),
      otp: otp.otp1 + otp.otp2 +otp.otp3 + otp.otp4 + otp.otp5 + otp.otp6
    }
    return {ename:ANALYTICS.SUBMIT_VERIFICATION_CODE,data:obj}
  }

   async function handleSubmit(event) {
    let analyticsData=await getSubmitVerificationAnalytics();
    pubsub.publish('user-analytics',analyticsData);
    let isCheckoutInitiate =  parseJSON(sessionStorage.getItem('checkout-initiate') || '')
    event.preventDefault()
    let otpValue = otp.otp1 + otp.otp2 +otp.otp3 + otp.otp4 + otp.otp5 + otp.otp6
    handleStatusGaCalls({eventName : 'submit_verification_code',subSection : null, type : 'verification', reason : otpValue, status : null, action : 'Request Code', paymentStatus : null,eventCategory : 'Verification'})
   switch(screenType.type){
    case "email" :
        setLoading(true)
        verifyEmail({
          "email":data,
          "otpValue":otp.otp1 + otp.otp2 +otp.otp3 + otp.otp4 + otp.otp5 + otp.otp6,
          "key":keyState || keyProp,
          "emailConsent":consent
        }).then(async (response) => {
          let res = response?.identityAuthOtpValidate
            pubsub.publish('user-analytics',{ename:ANALYTICS.VERIFY_EMAIL,data:{email:data}})
            await updateAuthorisationStore({userdetails:res})
            pushStepToFlow("email added")
            publishUserCreated({status : true })
            res.existingUser && triggerUserMergeEvent(res.existingUser)
            triggerCheckoutSigninStatus('CHECKOUT_USER_LOGIN_SUCCESS', true)
            if (isCheckoutInitiate) {
              handleStatusGaCalls({eventName : 'checkout_user_login_success',subSection : null, type : 'login', reason : 'true', status : null, action : 'Login Success', paymentStatus : null,eventCategory : 'Checkout'})
            }else {
              handleStatusGaCalls({eventName : 'login_success',subSection : 'login', type : 'success', reason : null, status : null, action : 'Success', paymentStatus : null,eventCategory : 'Authentication'})
            }
            if(isSplashLogin){
              sessionStorage.removeItem("splashLoginEmail")
              navigate("/")
              return
            }
            if(res.isSubscribed) pubsub.publish("isAuthenticated",{...res,provider:'EMAIL'})
              else pubsub.publish('isAuthenticated',{isSubscribed:false,provider:'EMAIL'})
            // if(res.isSubscribed) pubsub.publish("user",{...res,provider:'EMAIL'})
            // else pubsub.publish('user',{isSubscribed:false,provider:'EMAIL'})
            setLoading(false)
            if(isFreeLogin || isCheckoutScreen){
              navigate("/")
            }
        }).catch((err)=>{
          console.log(err)
          triggerCheckoutSigninStatus('CHECKOUT_USER_LOGIN_FAILURE', false, err.message)
          pubsub.publish('user-analytics',{ename:ANALYTICS.LOGIN_FAILURE,data:{email:data,provider:'EMAIL'}});
          getErrorMessage(err.message)
          setLoading(false)
        })
        break;

    case "mobile": 
    setLoading(true)
        VerifyMobile({
          phoneNumber: data,
          "otpValue":otp.otp1 + otp.otp2 +otp.otp3 + otp.otp4 + otp.otp5 + otp.otp6,
          "key":keyState || keyProp
        }).then(async (response) => {
          let res = response?.identityAuthOtpValidate
          pubsub.publish('user-analytics',{ename:ANALYTICS.VERIFY_MOBILE,data:{mobileNumber:data}})
          await updateAuthorisationStore({userdetails:res})
          pushStepToFlow("phone number")
          publishUserCreated({status : true })
          res.existingUser && triggerUserMergeEvent(res.existingUser)
          triggerCheckoutSigninStatus('CHECKOUT_USER_LOGIN_SUCCESS', true)
          if (isCheckoutInitiate) {
            handleStatusGaCalls({eventName : 'checkout_user_login_success',subSection : null, type : 'login', reason : 'true', status : null, action : 'Login Success', paymentStatus : null,eventCategory : 'Checkout'})
          }else {
            handleStatusGaCalls({eventName : 'login_success',subSection : 'login', type : 'success', reason : null, status : null, action : 'Success', paymentStatus : null,eventCategory : 'Authentication'})
          }
          if(res.isSubscribed) pubsub.publish("isAuthenticated",{...res,provider:'MOBILE'})
            else pubsub.publish('isAuthenticated',{isSubscribed:false,provider:'MOBILE'})
          // if(data.isSubscribed) pubsub.publish("user",{...data,provider:'MOBILE'})
          // else pubsub.publish('user',{isSubscribed:false,provider:'MOBILE'})
          setLoading(false)
          if(isFreeLogin || isCheckoutScreen){
            navigate("/")
          }
        }).catch(async(err) => {
          triggerCheckoutSigninStatus('CHECKOUT_USER_LOGIN_FAILURE', false, err.message)
          pubsub.publish('user-analytics',{ename:ANALYTICS.LOGIN_FAILURE,data:{mobile:'data',provider:'MOBILE'}});
          getErrorMessage(err.message)
          setLoading(false)
          trackEvent(ANALYTICS.LOGIN_FAILURE, { provider:'MOBILE', phoneNumber: data, error: err.message }, null)
        })
        break;
    }
    event.preventDefault();
  }

   const inputfocus = (elmnt) => {

    if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
      const next = elmnt.target.tabIndex - 1;
      if (next > -1) {
        const ele = elmnt.target.form.elements
        ele[ele.length - 1].classList.add('disabled')
        ele[next].focus()
      }
    }
    else {
        const next = elmnt.target.tabIndex;
        if (next < 7) {
          elmnt.target.form.elements[next].classList.remove('disabled')
          elmnt.target.form.elements[next].focus()
        }
    }

  }

  let heading = screenType.type == "email" ? metadataMap?.enterCodeToVerifyEmail :  metadataMap?.enterCodeToVerifyMobile
  

  return (
    <div className='verifyOtp-container'>
      <div className='verifyOtp-heading'>{`${heading}`}</div>
      <div id="descriptionText" className='verifyOtp-description'>{`${description}` || "We have sent a verification code. Please enter the code below to verify."}</div>
       <form className='verifyOtp-form' onSubmit={handleSubmit}>
        <div className="otpContainer">

          <input
            autoFocus
            aria-labelledby="OTP First Digit"
            style={{ background: inputColor, borderColor: inputBorderColor }}
            name="otp1"
            autoComplete="one-time-code"
            type="text"
            inputMode='numeric'
            className="otpInput"
            value={otp.otp1}
            onChange={e => handleChange("otp1", e)}
            onPaste={(e) => handlePaste("otp1", e)}
            tabIndex="1" maxLength="1" onKeyUp={e => inputfocus(e)}

          />
          <input
            name="otp2"
            aria-labelledby="OTP Second Digit" 
            style={{ background: inputColor, borderColor: inputBorderColor }}
            type="text"
            autoComplete="one-time-code"
            inputMode='numeric'
            className="otpInput"
            value={otp.otp2}
            onChange={e => handleChange("otp2", e)}
            onPaste={(e) => handlePaste("otp2", e)}
            tabIndex="2" maxLength="1" onKeyUp={e => inputfocus(e)}

          />
          <input
            name="otp3"
            aria-labelledby="OTP Third Digit" 
            style={{ background: inputColor, borderColor: inputBorderColor }}
            type="text"
            autoComplete="one-time-code"
            inputMode='numeric'
            className="otpInput"
            value={otp.otp3}
            onChange={e => handleChange("otp3", e)}
            onPaste={(e) => handlePaste("otp3", e)}
            tabIndex="3" maxLength="1" onKeyUp={e => inputfocus(e)}

          />
          <input
            name="otp4"
            aria-labelledby="OTP Fourth Digit" 
            type="text"
            style={{ background: inputColor, borderColor: inputBorderColor }}
            autoComplete="one-time-code"
            inputMode='numeric'
            className="otpInput"
            value={otp.otp4}
            onChange={e => handleChange("otp4", e)}
            onPaste={(e) => handlePaste("otp4", e)}
            tabIndex="4" maxLength="1" onKeyUp={e => inputfocus(e)}
          />

          <input
            name="otp5"
            aria-labelledby="OTP Fifth Digit" 
            type="text"
            style={{ background: inputColor, borderColor: inputBorderColor }}
            autoComplete="one-time-code"
            inputMode='numeric'
            className="otpInput"
            value={otp.otp5}
            onChange={e => handleChange("otp5", e)}
            onPaste={(e) => handlePaste("otp5", e)}
            tabIndex="5" maxLength="1" onKeyUp={e => inputfocus(e)}
          />

          <input
            name="otp6"
            aria-labelledby="OTP Sixth Digit" 
            type="text"
            style={{ background: inputColor, borderColor: inputBorderColor }}
            autoComplete="one-time-code"
            inputMode='numeric'
            className="otpInput"
            value={otp.otp6}
            onChange={e => handleChange("otp6", e)}
            onPaste={(e) => handlePaste("otp6", e)}
            tabIndex="6" maxLength="1" onKeyUp={e => inputfocus(e)}
          />

        </div>
        <button aria-label="submit" className="verifyOtpButn site-cta-background-color site-cta-color disabled" data-test="otp-submit-btn" type="submit">
        {screenType.type ==='mobile' ? metadataMap?.verifyMobileTitle:metadataMap?.verifyEmailTitle || 'Submit'}
        </ button>
      </form>
      {seconds > 0 || minutes > 0 ? <></> :<div className='otpTimer'>
        <button aria-label="resend otp" style = {textColorStyle} className='resendOtp site-color' onClick={() => {setResendOtp(resendotp + 1), resetOtpTimer()}}>{metadataMap?.resendCodeButtonText || 'Resend Otp'}</button>
      </div>}
    
     {<button aria-label="verify otp" style = {textColorStyle} className='resendOtp site-cta-background-color site-cta-color' onClick={() => {
        sessionStorage.removeItem("splashLoginEmail")
        pubsub.publish('verifyOtp',{screen:false,type:screenType.type})
      }}>{screenType.type ==='mobile' ? metadataMap?.useDifferentMobileText :metadataMap?.useDifferentEmailText|| "Use Different creds."}</button>}
      {errMsg && <div className='errMessage site-cta-color'>{errorAlert()}{errMsg}</div>}
      {loading && 
      <div className='loaderWrapper'>
        <Spinner />
      </div>}
    </div>
    );
  }


export default VerifyOtp;